const GUEST_VISITOR_KEY = 'livenow.guestVisitor';
const PENDING_SEARCH_KEY = 'livenow.pendingSearch';
const LAST_SEARCH_KEY = 'livenow.lastSearch';
const VISITOR_RE = /^[A-Za-z0-9_-]{8,64}$/;

function readStorage(store, key) {
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(store, key, value) {
  try {
    store.setItem(key, value);
  } catch {
    // Safari private mode and quota errors should not break search.
  }
}

function removeStorage(store, key) {
  try {
    store.removeItem(key);
  } catch {
    // ignore
  }
}

export function isValidVisitorId(id) {
  return typeof id === 'string' && VISITOR_RE.test(id);
}

export function getGuestVisitorId() {
  const id = readStorage(localStorage, GUEST_VISITOR_KEY);
  return isValidVisitorId(id) ? id : null;
}

export function persistGuestVisitorId(id) {
  if (!isValidVisitorId(id)) return;
  writeStorage(localStorage, GUEST_VISITOR_KEY, id);
}

export function persistVisitorFromHeaders(headers) {
  if (!headers) return;
  const id = headers['x-livenow-visitor'] || headers['X-Livenow-Visitor'];
  persistGuestVisitorId(id);
}

export function getGuestRequestHeaders() {
  const id = getGuestVisitorId();
  return id ? { 'X-Livenow-Visitor': id } : {};
}

export function rememberSearchQuery(query) {
  const q = typeof query === 'string' ? query.trim() : '';
  if (!q) return;
  writeStorage(sessionStorage, LAST_SEARCH_KEY, q);
}

export function persistPendingSearch(query) {
  let q = typeof query === 'string' ? query.trim() : '';
  if (!q) {
    q = (readStorage(sessionStorage, LAST_SEARCH_KEY) || '').trim();
  }
  if (!q) return;
  writeStorage(sessionStorage, PENDING_SEARCH_KEY, JSON.stringify({ query: q }));
}

export function consumePendingSearch() {
  const raw = readStorage(sessionStorage, PENDING_SEARCH_KEY);
  removeStorage(sessionStorage, PENDING_SEARCH_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    const query = typeof parsed?.query === 'string' ? parsed.query.trim() : '';
    return query ? { query } : null;
  } catch {
    return null;
  }
}

export function goToSignup(navigate, query) {
  persistPendingSearch(query);
  navigate('/signup');
}

export function goToLogin(navigate, query) {
  persistPendingSearch(query);
  navigate('/login');
}
